import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { queryFnFetchErrorWrapper } from 'src/api/utils/errorHandlers';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { FetchError } from 'src/types/TApiQueries';
import { getAdminUserSettings } from '../functions/adminUserSettingsApi';

export const adminUserSettingsQueryKey = (userId: number) => ['adminUserSettings', userId];

export function useAdminUserSettingsQuery(
  userId: number | undefined,
  queryOptions?: UseQueryOptions<any, FetchError>,
) {
  const accessToken = useAccessToken();

  const fetchFn = async () => {
    if (!userId) throw new Error('userId is required');
    const result = (await getAdminUserSettings(userId, accessToken)) as any;
    return result.data ?? result;
  };

  const queryFn = useMemo(() => queryFnFetchErrorWrapper(fetchFn), [userId, accessToken]);

  return useQuery<any, FetchError>(
    adminUserSettingsQueryKey(userId!),
    queryFn,
    {
      enabled: !!userId,
      ...queryOptions,
    },
  );
}
